import { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

//Primereact components
import { Toast } from 'primereact/toast';
import { Toolbar } from 'primereact/toolbar';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Dialog } from 'primereact/dialog';
import { Badge } from 'primereact/badge';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';

// Column
import { FreshApplicationColumns } from '../../../appconfig/DatatableSetting';

// Data table
import { defaultRowOptions, defaultPageRowOptions, Skeletonitems, SkeletonbodyTemplate, transferApplicationName, paginatorLinks, showingEntries, ApplicationStatusOptions } from '../../../appconfig/Settings';

//Services
import { deleteDataWithMultipleParameters, getAllDetails } from '../../../service/ProductService';

import { applicationsAppointmentDateTemplate, applicationsFullNameTemplate, collegeNameTemplate, payDtTemplate } from '../../../appconfig/DatatableTemplateSetting';
import { DELETE_REFUND, GET_APPLICATIONLIST } from '../../../config/ApiConstant';
import { checkEmail, setAppStatus } from '../../../appconfig/AppHelper';
import moment from 'moment';
import { ApplicationTab } from '../applicationTab';
import { FreshApplicationTab } from './FreahApplicationTab';
import CustomDatePicker from '../../../components/CustomDatePicker/CustomDatePicker';

export const FreshApplicationDamanAndDiu = () => {
    document.title = 'Transfer DD/DNH | GSPC';

    //Set Toast/ Filter Properties
    const toast = useRef<any>(null);
    const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);
    const [globalFilter, setGlobalFilter] = useState<any>(null);

    // Date Object
    const storedDates = localStorage.getItem('fresh_app');
    let initialStartDate = moment().subtract(30, 'days').toDate();
    let initialEndDate = moment().toDate();

    if (storedDates) {
        try {
            const parsed = JSON.parse(storedDates);
            initialStartDate = parsed.startDate ? new Date(parsed.startDate) : initialStartDate;
            initialEndDate = parsed.endDate ? new Date(parsed.endDate) : initialEndDate;
        } catch (error) {
            console.error('Error parsing stored dates', error);
        }
    }

    const [dates, setDates] = useState({
        start: initialStartDate,
        end: initialEndDate
    });

    // Navigate
    const navigate = useNavigate();

    //Loading/Page Loading
    const [pageLoad, setPageLoad] = useState<boolean>(false);
    const [applicationsList, setApplicationsList] = useState<any>([]);
    const [deleteModal, setDeleteModal] = useState<boolean>(false);
    const [deleteId, setDeleteId] = useState<any>(null);
    const [deleteBillSrNo, setDeleteBillSrNo] = useState<any>(null);
    const [deleteLoader, setDeleteLoader] = useState<boolean>(false);
    const [appStatusFilter, setAppStatusFilter] = useState<any>({ name: 'All', code: 'All' });
    const [isEmail, setIsEmail] = useState<boolean>(false);
    const [searchVal, setSearchVal] = useState<any>(null);

    // useEffect
    useEffect(() => {
        getApplicationsList();

        //check mail for refund
        const mail = checkEmail(localStorage.getItem('email'));
        if (mail) {
            setIsEmail(true);
        }
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, [dates]);

    // On Date Change
    const onDateChange = (start: any, end: any) => {
        setDates({ start, end });

        if (start && end) {
            localStorage.setItem(
                'fresh_app',
                JSON.stringify({
                    startDate: moment(start).format('YYYY-MM-DD'),
                    endDate: moment(end).format('YYYY-MM-DD')
                })
            );
        }
    };

    // Get applications list from api
    const getApplicationsList = async () => {
        try {
            setPageLoad(false);
            let startDate = moment(dates?.start).format('y-M-D') + ' 00:00:00';
            let endDate = moment(dates?.end).format('y-M-D') + ' 23:59:59';
            const response = await getAllDetails(GET_APPLICATIONLIST + '?AppNm=' + transferApplicationName + '&tab_type=payment_done&start_date=' + startDate + '&end_date=' + endDate + '&search=' + searchVal);
            if (response) {
                const DataList: any = response;

                if (DataList.length === 0) {
                    setApplicationsList([]);
                } else {
                    setApplicationsList(DataList);
                }
                setPageLoad(true);
            } else {
                setPageLoad(false);
                setApplicationsList([]);
            }
        } catch (error: any) {
            setPageLoad(false);
            setApplicationsList([]);
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry Could Not Load Data'
            });
        }
    };

    // Global search
    const leftToolbarTemplate = () => {
        return (
            <>
                <span className="block mt-2 md:mt-0 p-input-icon-left mr-3">
                    <i className="pi pi-search"></i>
                    <InputText value={searchVal} onChange={(e) => setSearchVal(e.target.value)} placeholder="Search..." className="" />
                    <i className="pi pi-times input-s" onClick={() => removeSearch()} style={{ right: '10px', zIndex: '111111', cursor: 'pointer' }}></i>
                </span>

                <Button label="" icon="pi pi-search" className="p-button p-button-rounded" onClick={() => getApplicationsList()} />
                {/* <Button label="Booked Appointments" className="p-button mr-2" onClick={() => navigate("/app/application/fresh-registration/booked-appointment-list")} /> */}
            </>
        );
    };

    const removeSearch = () => {
        setSearchVal(null);
        setGlobalFilter(null);
        getApplicationsList();
    };

    //Clear All Filter
    const clearAll = () => {
        setGlobalFieldFilter(null);
    };

    // Right toolbar
    const rightToolbarTemplate = () => {
        return (
            <>
                <CustomDatePicker startDate={dates.start} endDate={dates.end} onChange={onDateChange} />

                <Button icon="pi pi-filter-slash" label="Clear" onClick={() => clearAll()} className="p-button-outlined ml-2"></Button>
            </>
        );
    };

    // Open delete with refund modal
    const openDeleteWithRefundModal = (id: any, billSrNo: any) => {
        setDeleteId(id);
        setDeleteBillSrNo(billSrNo);
        setDeleteModal(true);
    };

    // Close delete with refund modal
    const closeDeleteWithRefundModal = () => {
        setDeleteId(null);
        setDeleteBillSrNo(null);
        setDeleteLoader(false);
        setDeleteModal(false);
    };

    // Template for actions
    const actionsTemplate = (rowData: any, rowIndex: any) => {
        return (
            <>
                <div className="actions action-btn">
                    {isEmail === true && <Button icon="pi pi-trash" tooltip="Delete With Refund" tooltipOptions={{ position: 'top' }} className="p-button-danger ml-2" onClick={() => openDeleteWithRefundModal(rowData.id, rowData?.BillSrNo)} />}
                </div>
            </>
        );
    };

    // Template for status
    const statusTemplate = (rowData: any, rowIndex: any) => {
        let appStatusVal = setAppStatus(rowData.appStatus);
        return (
            <>
                <Badge severity={appStatusVal.severity} value={appStatusVal.value}></Badge>
            </>
        );
    };

    // Template for comment
    const commentTemplate = (rowData: any, rowIndex: any) => {
        return (
            <>
                {rowData.appStatus === 'Rejected' || rowData.appStatus === 'Hold' ? (
                    <Button tooltip={rowData?.comment} className="p-button-custom-tooltip" tooltipOptions={{ position: 'top' }}>
                        <div className="college-name-div">{rowData?.comment}</div>
                    </Button>
                ) : (
                    '-'
                )}
            </>
        );
    };

    // Delete with refund api call
    const deleteWithRefundApiCall = async () => {
        try {
            setDeleteLoader(true);
            // Delete api call
            const response = await deleteDataWithMultipleParameters(DELETE_REFUND + '?sr_no=' + deleteId + '&app_name=' + transferApplicationName + '&transaction_id=' + deleteBillSrNo);
            if (response) {
                toast.current?.show({
                    severity: 'success',
                    summary: 'Success',
                    detail: response?.message
                });
                setDeleteLoader(false);
                setDeleteModal(false);
                setDeleteId(null);
                setDeleteBillSrNo(null);
                getApplicationsList();
            } else {
                setPageLoad(false);
                toast.current?.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Something went wrong, Please try again.'
                });
                setDeleteLoader(false);
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setDeleteLoader(false);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Something Went Wrong' });
            }
        }
    };

    // On row select action
    const onRowSelection = (value: any) => {
        navigate('/app/application/applicationViewForm/' + btoa(value.SrNo));
    };

    // Search by app status
    const searchByAppStatus = (options: any) => {
        return (
            <Dropdown
                filter
                value={appStatusFilter}
                onChange={(e: any) => {
                    setAppStatusFilter(e.value);
                    options.filterCallback(e.value.code, options.index);
                }}
                options={ApplicationStatusOptions}
                optionLabel="name"
                placeholder="Search By Status"
                className="order-drp"
            ></Dropdown>
        );
    };

    return (
        <>
            
            <ApplicationTab mainTabLabel="Fresh Application" />
            <FreshApplicationTab initialTabLabel="Transfer DD/DNH"  />
            <Toast ref={toast} />
            {/* <AppBreadcrumb currentMenu={'Applications'} pageName={'Fresh Application'} pageTitle={'Fresh Application'} /> */}
            <div className="grid crud-demo">
                <div className="col-12">
                    <div className="card">
                        <Toolbar left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>

                        {/* Datatable */}
                        {pageLoad ? (
                            <>
                                <DataTable
                                    value={applicationsList}
                                    showGridlines
                                    stripedRows
                                    globalFilter={globalFilter}
                                    filters={globalFieldFilter}
                                    rows={defaultRowOptions}
                                    paginator={applicationsList.length >= 10 && true}
                                    rowsPerPageOptions={defaultPageRowOptions}
                                    onFilter={(e) => setGlobalFieldFilter(e.filters)}
                                    className="datatable-responsive p-datatable-sm"
                                    emptyMessage="No Applications Found"
                                    selectionMode="single"
                                    paginatorTemplate={paginatorLinks}
                                    currentPageReportTemplate={showingEntries}
                                    onSelectionChange={(e) => onRowSelection(e.value)}
                                >
                                    {FreshApplicationColumns.map((col, i) => {
                                        if (col.field === 'action') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={actionsTemplate} />;
                                        } else if (col.field === 'appointment_date') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={applicationsAppointmentDateTemplate} sortable />;
                                        } else if (col.field === 'status') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={statusTemplate} filter filterElement={searchByAppStatus} />;
                                        } else if (col.field === 'PayDt') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={payDtTemplate} sortable />;
                                        } else if (col.field === 'comment') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={commentTemplate} style={{maxWidth : "13rem"}} />;
                                        } else if (col.field === 'full_name') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={applicationsFullNameTemplate} sortable filter filterPlaceholder={'Search by ' + col.header} />;
                                        } else if (col.field === 'ColName') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={collegeNameTemplate} sortable filter filterPlaceholder={'Search by ' + col.header} />;
                                        } else {
                                            return <Column key={col.field} field={col.field} header={col.header} filter filterPlaceholder={'Search by ' + col.header} />;
                                        }
                                    })}
                                </DataTable>
                                {/* <Paginator first={first} rows={perPage} totalRecords={totalRecords} rowsPerPageOptions={defaultPageRowOptions} onPageChange={onPageChange} /> */}
                            </>
                        ) : (
                            <>
                                {/* Skeleton Data table */}
                                <DataTable value={Skeletonitems}>
                                    {FreshApplicationColumns.map((col, i) => (
                                        <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                                    ))}
                                </DataTable>
                            </>
                        )}
                    </div>
                </div>
            </div>

            {/* Delete With Refund Dialog */}
            <Dialog
                visible={deleteModal}
                style={{ width: '450px' }}
                header="Delete Application"
                modal
                footer={
                    <>
                        <Button label="Cancel" className="p-button-secondary" onClick={closeDeleteWithRefundModal} />
                        <Button label="Delete With Refund" className="p-button-danger" onClick={deleteWithRefundApiCall} loading={deleteLoader} />
                    </>
                }
                onHide={closeDeleteWithRefundModal}
            >
                <div className="flex align-items-center justify-content-start">
                    <i className="pi pi-exclamation-triangle mr-3 delete-triangle" style={{ fontSize: '2rem' }} />
                    <span className="delete-dialog-note">Note: Once you delete this Application, This will be deleted permanently.</span>
                </div>
            </Dialog>
        </>
    );
};
